var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex",staticStyle:{"height":"60px","overflow-y":"none","overflow-x":"hidden","white-space":"nowrap"}},_vm._l((4),function(i){return _c('v-skeleton-loader',{key:i,staticClass:"ma-2",attrs:{"type":"chip"}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }